import React from "react";
import moment from "moment";

import { Grid, Typography } from "@material-ui/core";

import SwitchButton from "components/common/SwitchButton/SwitchButton";
import SelectBox from "components/common/SelectBox/SelectBox";

import {
  MAXIMUM_MARK_BUSY_TIME_HOURS,
  MAXIMUM_MARK_BUSY_TIME_MINUTES,
  POS_ZONE_STATE_STATUS,
} from "../utils/constants";
import { isEmptyOrNull } from "../../../utils/DataUtils";
import { convertUTCDate } from "../../../utils/helperFunctions";
import { PRODUCT_TYPES } from "config/constants";

interface RenderExpressDefineBusyPeriodInterface {
  classes: any;
  state: string;
  stateEdit: boolean;
  busyDurationHour: number | string;
  busyDurationMinutes: number | string;
  busyEndTime?: any;
  timezone?: any;
  handleZoneStateSwitch?: any;
  handleChangeConfigurationStateSwitch: any;
  onBusyTimeFieldsChange: (name: string, event: any) => void;
  offlineOrderEnabled: boolean;
  busyOrderEnabled: boolean;
  handleBusyOrderChange: (event: any) => void;
  handleOfflineOrderChange: (event: any) => void;
}

const RenderExpressDefineBusyPeriod = (
  props: RenderExpressDefineBusyPeriodInterface
) => {
  const {
    classes,
    state,
    stateEdit,
    busyDurationHour,
    busyDurationMinutes,
    busyEndTime,
    timezone,
    handleZoneStateSwitch,
    handleChangeConfigurationStateSwitch,
    onBusyTimeFieldsChange,
    offlineOrderEnabled,
    busyOrderEnabled,
    handleBusyOrderChange,
    handleOfflineOrderChange,
  } = props;
  const convertDate = () => {
    if (busyEndTime) {
      if (timezone) {
        return moment(convertUTCDate(busyEndTime, timezone)).format(
          "MMMM Do YYYY, h:mm a"
        );
      }
      return moment(convertUTCDate(busyEndTime)).format("MMMM Do YYYY, h:mm a");
    }
    return "";
  };

  return (
    <Grid container spacing={1} className={classes.detailsSection}>
      <Grid item xs={12}>
        <Grid container spacing={0}>
          <Grid item xs={6}>
            <Typography
              className={classes.headingTitleStyle}
            >{PRODUCT_TYPES.STORE_AVAILABILITY}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={3} className={classes.marginAutoLeftright}>
            <SwitchButton
              leftLabel="Off"
              rightLabel="On"
              size="medium"
              checked={Boolean(state === POS_ZONE_STATE_STATUS.AVAILABLE)}
              handleChange={stateEdit ? undefined : handleZoneStateSwitch}
              onClick={(e: any) => e.stopPropagation()}
              disabled={false}
              className={stateEdit ? classes.disabledSwitch : ""}
            />
          </Grid>
          <Grid item xs={9}>
            {state === POS_ZONE_STATE_STATUS.BUSY ? (
              isEmptyOrNull(busyEndTime) ? (
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <SelectBox
                      fieldLabel=""
                      name="busyDurationHour"
                      label="Hour"
                      value={busyDurationHour}
                      handleChange={(e: any) =>
                        onBusyTimeFieldsChange("busyDurationHour", e)
                      }
                      menuItems={MAXIMUM_MARK_BUSY_TIME_HOURS}
                      disabled={false}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <SelectBox
                      fieldLabel=""
                      name="busyDurationMinutes"
                      label="Minute"
                      value={busyDurationMinutes}
                      handleChange={(e: any) =>
                        onBusyTimeFieldsChange("busyDurationMinutes", e)
                      }
                      menuItems={MAXIMUM_MARK_BUSY_TIME_MINUTES}
                      disabled={false}
                    />
                  </Grid>
                </Grid>
              ) : (
                <Typography className={classes.textStyle}>
                  {`Zone Active Time `}
                  <Typography
                    className={classes.textStyleBold}
                  >{` : ${convertDate()}`}</Typography>
                </Typography>
              )
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Typography className={`${classes.headingTitleStyle} ${classes.headingBusyOrderTitleStyle}`}>
          {PRODUCT_TYPES.BUSY_ORDER_ENABLED}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={3} className={classes.marginAutoLeftright}>
            <SwitchButton
              leftLabel="Off"
              rightLabel="On"
              size="medium"
              checked={Boolean(busyOrderEnabled)}
              handleChange={handleBusyOrderChange}
              disabled={false}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.headingTitleStyle}>
          {PRODUCT_TYPES.OFFLINE_ORDER_ENABLED}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={3} className={classes.marginAutoLeftright}>
            <SwitchButton
              leftLabel="Off"
              rightLabel="On"
              size="medium"
              checked={Boolean(offlineOrderEnabled)}
              handleChange={handleOfflineOrderChange}
              disabled={false}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default React.memo(RenderExpressDefineBusyPeriod);
